export const ASSETS = {
  "logos": {
    "splash": {
      "path": "https://ucarecdn.com/e7a36776-9549-4aaa-ba47-8e4867893d78/graph_drk.svg",
      "height": 300,
      "width": 300
    }
  },
  "avatars": {
    "alchemist": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1bcf63c161254429a06d4cc99fa31aeb/2a0e1741e40d4509a291b71d1c4fdc4e/preview/assets/avatars/player.png",
      "height": 300,
      "width": 300
    },
    "architect": {
      "path": "https://ucarecdn.com/28b120ea-04ba-4f20-9103-e132329f5b59/architect_avatar.png",
      "height": 300,
      "width": 300
    },
    "astronaut": {
      "path": "https://ucarecdn.com/04dde179-9f43-407e-a0f0-9e4b2e82e821/astronaut.png",
      "height": 300,
      "width": 300
    },
    "bard": {
      "path": "https://ucarecdn.com/b4546292-277f-404c-8999-30ba8b408ca1/bard_avatar.png",
      "height": 300,
      "width": 300
    },
    "flintknapper": {
      "path": "https://ucarecdn.com/d9e33cbb-4c6c-4ee2-913e-7b3bfe98dd79/flintknapper_avatar.png",
      "height": 300,
      "width": 300
    },
    "hacker": {
      "path": "https://ucarecdn.com/9cf2fa4e-9994-4680-b715-bf58c4aa40da/hacker_avatar.png",
      "height": 300,
      "width": 300
    },
    "inventor": {
      "path": "https://ucarecdn.com/80e7fe09-3a88-4484-a87a-5dc91d4302a0/inventor_avatar.png",
      "height": 300,
      "width": 300
    }
  },
  "backgrounds": {
    "bronze_age": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1bcf63c161254429a06d4cc99fa31aeb/06a1c41b9f4d4d209ed781f88da053c4/preview/assets/backgrounds/bronze_age.png",
      "height": 900,
      "transparent": false,
      "width": 1600
    },
    "card_battle": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1bcf63c161254429a06d4cc99fa31aeb/7a0db4371f9b4aa0b071fae4c5c06b5a/preview/assets/backgrounds/card_battle.png",
      "height": 900,
      "width": 1600
    },
    "classical_age": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1bcf63c161254429a06d4cc99fa31aeb/06a1c41b9f4d4d209ed781f88da053c4/preview/assets/backgrounds/classical_age.png",
      "height": 900,
      "transparent": false,
      "width": 1600
    },
    "industrial_age": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/cad1c82cf1b84732b811580cd8264bf9/main/preview/assets/backgrounds/industrial_age.png",
      "height": 300,
      "width": 300
    },
    "information_age": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1bcf63c161254429a06d4cc99fa31aeb/425abb06fe39448abcc355acd40e602a/preview/assets/backgrounds/information_age.png",
      "height": 900,
      "transparent": false,
      "width": 1600
    },
    "main_menu": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/5bb291c9fd8d4e62a9c51cf05a36f2f8/654dc13fb0064f60aa22db2e470b5708/preview/assets/backgrounds/main_menu.png",
      "height": 900,
      "width": 1600
    },
    "medieval_age": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1bcf63c161254429a06d4cc99fa31aeb/06a1c41b9f4d4d209ed781f88da053c4/preview/assets/backgrounds/medieval_age.png",
      "height": 300,
      "width": 300
    },
    "modern_age": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1bcf63c161254429a06d4cc99fa31aeb/06a1c41b9f4d4d209ed781f88da053c4/preview/assets/backgrounds/modern_age.png",
      "height": 300,
      "width": 300
    },
    "primordial_age": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1bcf63c161254429a06d4cc99fa31aeb/a63c028a41ba4a3b9746a319befe3d55/preview/assets/backgrounds/primordial_age.png",
      "height": 900,
      "transparent": false,
      "width": 1600
    },
    "renaissance": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1bcf63c161254429a06d4cc99fa31aeb/84670c0131854ca3b28ffda86c065f0a/preview/assets/backgrounds/renaissance.png",
      "height": 900,
      "transparent": false,
      "width": 1600
    },
    "space_age": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1bcf63c161254429a06d4cc99fa31aeb/06a1c41b9f4d4d209ed781f88da053c4/preview/assets/backgrounds/space_age.png",
      "height": 900,
      "transparent": false,
      "width": 1600
    },
    "stone_age": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1bcf63c161254429a06d4cc99fa31aeb/a63c028a41ba4a3b9746a319befe3d55/preview/assets/backgrounds/stone_age.png",
      "height": 900,
      "transparent": false,
      "width": 1600
    }
  },
  "bosses": {
    "bronze_age": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1bcf63c161254429a06d4cc99fa31aeb/543c021e18494c628e28f9e9f1dc1978/preview/assets/bosses/khenti_bronze_warden.png",
      "height": 300,
      "width": 300
    },
    "classical_age": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1bcf63c161254429a06d4cc99fa31aeb/543c021e18494c628e28f9e9f1dc1978/preview/assets/bosses/marcus_philosophicus.png",
      "height": 300,
      "width": 300
    },
    "industrial_age": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1bcf63c161254429a06d4cc99fa31aeb/543c021e18494c628e28f9e9f1dc1978/preview/assets/bosses/baron_steamheart.png",
      "height": 300,
      "width": 300
    },
    "information_age": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1bcf63c161254429a06d4cc99fa31aeb/543c021e18494c628e28f9e9f1dc1978/preview/assets/bosses/cypher_networked.png",
      "height": 300,
      "width": 300
    },
    "medieval_age": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1bcf63c161254429a06d4cc99fa31aeb/543c021e18494c628e28f9e9f1dc1978/preview/assets/bosses/sir_aldric_ironbound.png",
      "height": 300,
      "width": 300
    },
    "modern_age": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1bcf63c161254429a06d4cc99fa31aeb/543c021e18494c628e28f9e9f1dc1978/preview/assets/bosses/general_atomicus.png",
      "height": 300,
      "width": 300
    },
    "renaissance": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1bcf63c161254429a06d4cc99fa31aeb/543c021e18494c628e28f9e9f1dc1978/preview/assets/bosses/leonardo_da_machina.png",
      "height": 300,
      "width": 300
    },
    "space_age": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1bcf63c161254429a06d4cc99fa31aeb/543c021e18494c628e28f9e9f1dc1978/preview/assets/bosses/cosmos_eternal.png",
      "height": 300,
      "width": 300
    },
    "stone_age": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1bcf63c161254429a06d4cc99fa31aeb/543c021e18494c628e28f9e9f1dc1978/preview/assets/bosses/grok_flintkeeper.png",
      "height": 300,
      "width": 300
    }
  },
  "card_frames": {
    "default": {
      "path": "https://ucarecdn.com/a63c028a-41ba-4a3b-9746-a319befe3d55/default_frame.png",
      "height": 192,
      "width": 128
    },
    "infrastructure": {
      "path": "https://ucarecdn.com/543c021e-1849-4c62-8e28-f9e9f1dc1978/infrastructure_frame.png",
      "height": 192,
      "width": 128
    },
    "knowledge": {
      "path": "https://ucarecdn.com/84670c01-3185-4ca3-b28f-fda86c065f0a/knowledge_frame.png",
      "height": 192,
      "width": 128
    },
    "materials": {
      "path": "https://ucarecdn.com/1bcf63c1-6125-4429-a06d-4cc99fa31aeb/materials_frame.png",
      "height": 192,
      "width": 128
    },
    "nature": {
      "path": "https://ucarecdn.com/4ab87db2-ed6b-493e-a074-e5d59ffd474f/nature_frame.png",
      "height": 192,
      "width": 128
    },
    "society": {
      "path": "https://ucarecdn.com/425abb06-fe39-448a-bcc3-55acd40e602a/society_frame.png",
      "height": 192,
      "width": 128
    },
    "technology": {
      "path": "https://ucarecdn.com/2a0e1741-e40d-4509-a291-b71d1c4fdc4e/technology_frame.png",
      "height": 192,
      "width": 128
    }
  },
  "icons": {
    "ai_core": {
      "path": "https://ucarecdn.com/791a395e-26af-4279-92a9-c87da21d1fe2/ai_core.png",
      "height": 300,
      "width": 300
    },
    "air": {
      "path": "https://ucarecdn.com/71a47f6f-bd11-48f9-9166-521a22923567/air.png",
      "height": 300,
      "width": 300
    },
    "airplane": {
      "path": "https://ucarecdn.com/7bfe20d3-a1ca-4f2f-ba78-04d12f38e819/airplane.png",
      "height": 300,
      "width": 300
    },
    "animal": {
      "path": "https://ucarecdn.com/7f3c4858-fc7a-4ffc-8715-f48c5ca839da/animal.png",
      "height": 300,
      "width": 300
    },
    "arena": {
      "path": "https://ucarecdn.com/746868b2-836f-4649-9d10-a7808f7d0ca9/arena.png",
      "height": 300,
      "width": 300
    },
    "army": {
      "path": "https://ucarecdn.com/29525e75-a1a1-4490-a8d8-546d85203892/army.png",
      "height": 300,
      "width": 300
    },
    "art": {
      "path": "https://ucarecdn.com/bc9309ea-3a26-4427-823f-fb48f7cc9bc6/art.png",
      "height": 300,
      "width": 300
    },
    "bank": {
      "path": "https://ucarecdn.com/9afa5992-ad55-4af2-bf21-963c0ec5a500/bank.png",
      "height": 300,
      "width": 300
    },
    "bridge": {
      "path": "https://ucarecdn.com/36c58635-e0c6-43c6-8543-658244b4772d/bridge.png",
      "height": 300,
      "width": 300
    },
    "building": {
      "path": "https://ucarecdn.com/751da5df-4c78-4768-ae77-1b60ad454f33/building.png",
      "height": 300,
      "width": 300
    },
    "car": {
      "path": "https://ucarecdn.com/52ad7c25-556c-4330-bf4f-2e8efe78c1f2/car.png",
      "height": 300,
      "width": 300
    },
    "castle": {
      "path": "https://ucarecdn.com/b9533a63-7590-42ab-863d-c5caddf13183/castle.png",
      "height": 300,
      "width": 300
    },
    "catapult": {
      "path": "https://ucarecdn.com/0a10bea7-040f-4384-bcbd-5fad085fae8e/catapult.png",
      "height": 300,
      "width": 300
    },
    "chip": {
      "path": "https://ucarecdn.com/867c8daa-9c8e-4063-87c0-c7056bcf8b4d/chip.png",
      "height": 300,
      "width": 300
    },
    "church": {
      "path": "https://ucarecdn.com/36dc6d30-325d-4730-9148-7bbdf997bb60/church.png",
      "height": 300,
      "width": 300
    },
    "clay": {
      "path": "https://ucarecdn.com/4fab6a5a-dab5-4a51-a3ec-3a8f60b55842/clay.png",
      "height": 300,
      "width": 300
    },
    "clothing": {
      "path": "https://ucarecdn.com/8834b711-4324-4dd6-8eb2-cbc413f189cc/clothing.png",
      "height": 300,
      "width": 300
    },
    "computer": {
      "path": "https://ucarecdn.com/03aef1ae-9033-4c3c-bca2-444069c9bc7f/computer.png",
      "height": 300,
      "width": 300
    },
    "cooking": {
      "path": "https://ucarecdn.com/c6440473-105a-45d6-88ac-c2ef8dc76c13/cooking.png",
      "height": 300,
      "width": 300
    },
    "deck": {
      "path": "https://ucarecdn.com/10d5d850-5b93-4f9f-b46d-5decc9ead460/deck.png",
      "height": 300,
      "width": 300
    },
    "default": {
      "path": "https://ucarecdn.com/e3830f28-76d3-4681-af99-ee31542823a9/locked_object.png",
      "height": 300,
      "width": 300
    },
    "earth": {
      "path": "https://ucarecdn.com/9f18f003-9335-408a-baf1-d7294d7f6b89/earth_element.png",
      "height": 300,
      "width": 300
    },
    "electricity": {
      "path": "https://ucarecdn.com/a4428b40-d3a0-46ce-8996-406e7930f3bc/electricity.png",
      "height": 300,
      "width": 300
    },
    "engine": {
      "path": "https://ucarecdn.com/de81a64d-5411-4798-8080-da5425ac8e3a/engine.png",
      "height": 300,
      "width": 300
    },
    "factory": {
      "path": "https://ucarecdn.com/977cf7a7-dcc2-41d2-aa40-19a9a0b8a9ad/factory.png",
      "height": 300,
      "width": 300
    },
    "farm": {
      "path": "https://ucarecdn.com/3acf0aed-2b06-453f-9bab-b5e441f3a4e5/farm.png",
      "height": 300,
      "width": 300
    },
    "feast": {
      "path": "https://ucarecdn.com/687a7424-a291-467d-aa1e-af6cf93e7c49/feast.png",
      "height": 300,
      "width": 300
    },
    "festival": {
      "path": "https://ucarecdn.com/6202663f-dcc6-4520-8fb9-1132c67f4b27/festival.png",
      "height": 300,
      "width": 300
    },
    "fire": {
      "path": "https://ucarecdn.com/e9b8036d-4aa4-4fd0-97dd-7a548f5aab92/fire.png",
      "height": 300,
      "width": 300
    },
    "fishing": {
      "path": "https://ucarecdn.com/a664318f-58f7-4418-af7c-7e4ed068d277/fishing.png",
      "height": 300,
      "width": 300
    },
    "game": {
      "path": "https://ucarecdn.com/1fce0237-e612-4af3-829a-0948ed1a8b53/ancient_game.png",
      "height": 300,
      "width": 300
    },
    "glass": {
      "path": "https://ucarecdn.com/0b1257d5-fbb1-41ec-8de0-591ec6f70088/glass_material.png",
      "height": 300,
      "width": 300
    },
    "globe": {
      "path": "https://ucarecdn.com/fdc9d812-6eb9-4aa4-9283-55aa8f4a590d/globe.png",
      "height": 300,
      "width": 300
    },
    "gold": {
      "path": "https://ucarecdn.com/cce93259-eafd-4dc6-a466-25a9f82b979c/gold.png",
      "height": 300,
      "width": 300
    },
    "hint": {
      "path": "https://ucarecdn.com/7ec6d3e7-f900-4426-90d9-51a2369c3156/hint.png",
      "height": 300,
      "width": 300
    },
    "horse": {
      "path": "https://ucarecdn.com/5bcb72de-93ba-4487-8835-cdfd72c452b7/horse.png",
      "height": 300,
      "width": 300
    },
    "hunting": {
      "path": "https://ucarecdn.com/0f7ca987-0f39-43a7-aeae-f1dfc70795b5/hunting.png",
      "height": 300,
      "width": 300
    },
    "internet": {
      "path": "https://ucarecdn.com/788201fd-21c0-4978-9087-d9452cf8cdd1/internet.png",
      "height": 300,
      "width": 300
    },
    "knight": {
      "path": "https://ucarecdn.com/754cf586-7f12-4304-83ff-9c79e12daeeb/knight.png",
      "height": 300,
      "width": 300
    },
    "light": {
      "path": "https://ucarecdn.com/e559d1d6-57df-4a93-9995-9546cd5c7ed7/light.png",
      "height": 300,
      "width": 300
    },
    "lightning": {
      "path": "https://ucarecdn.com/4e2751f8-9473-4656-9ba0-39d12a0e5f0a/lightning.png",
      "height": 300,
      "width": 300
    },
    "link": {
      "path": "https://ucarecdn.com/40d14137-7ba5-42f6-8c29-8547167098e0/link.png",
      "height": 300,
      "width": 300
    },
    "map": {
      "path": "https://ucarecdn.com/059cf1f4-4dc4-4a9b-bb1b-5ba980e4deb8/map.png",
      "height": 300,
      "width": 300
    },
    "market": {
      "path": "https://ucarecdn.com/7db1b313-b73b-4a92-8aa0-f949d263c6ce/market.png",
      "height": 300,
      "width": 300
    },
    "mars_colony": {
      "path": "https://ucarecdn.com/7730d8d6-f00a-4e66-861b-c3fa25bdd82b/mars_colony.png",
      "height": 300,
      "width": 300
    },
    "mech_god": {
      "path": "https://ucarecdn.com/283bfab9-3219-4144-b67c-a781dd16c1ba/mech_god.png",
      "height": 300,
      "width": 300
    },
    "metal": {
      "path": "https://ucarecdn.com/1a23a909-d992-486f-9007-d8c21cf4e255/metal.png",
      "height": 300,
      "width": 300
    },
    "music": {
      "path": "https://ucarecdn.com/d3101a9a-37b9-453d-b9e5-bd6ca468dcb3/music.png",
      "height": 300,
      "width": 300
    },
    "myth": {
      "path": "https://ucarecdn.com/3f495770-da3b-46a2-bf08-0701ce164fe7/myth.png",
      "height": 300,
      "width": 300
    },
    "nation": {
      "path": "https://ucarecdn.com/fa278736-051b-476a-8fe2-4e1001dea79e/nation.png",
      "height": 300,
      "width": 300
    },
    "network": {
      "path": "https://ucarecdn.com/6e89e59b-fdd0-46cc-b352-1b8d4af0a928/network.png",
      "height": 300,
      "width": 300
    },
    "node": {
      "path": "https://ucarecdn.com/cad2b628-6863-4165-a26d-a8f98bd82134/node.png",
      "height": 300,
      "width": 300
    },
    "plant": {
      "path": "https://ucarecdn.com/ae1c3a0b-3195-4d53-82e6-db1f3dc07c4a/plant.png",
      "height": 300,
      "width": 300
    },
    "plasma": {
      "path": "https://ucarecdn.com/655a2402-bb9c-44cc-ba66-8a1c7c956cea/plasma.png",
      "height": 300,
      "width": 300
    },
    "pottery": {
      "path": "https://ucarecdn.com/2fdd7fed-2018-45d1-bcc1-d3fe1c546c0e/pottery.png",
      "height": 300,
      "width": 300
    },
    "printing_press": {
      "path": "https://ucarecdn.com/b6c49eb6-e276-45b3-a191-4b67c972d0c2/printing_press.png",
      "height": 300,
      "width": 300
    },
    "religion": {
      "path": "https://ucarecdn.com/ab45a9fc-473e-4655-a2f0-178601afd8c9/religion.png",
      "height": 300,
      "width": 300
    },
    "ritual": {
      "path": "https://ucarecdn.com/0d40a993-7462-4f44-8c12-d774dbc854d5/ritual.png",
      "height": 300,
      "width": 300
    },
    "road": {
      "path": "https://ucarecdn.com/ba750cc3-e5d3-4d87-923d-46ddf03f7d04/road.png",
      "height": 300,
      "width": 300
    },
    "robot": {
      "path": "https://ucarecdn.com/4092deb0-0fb8-4a84-ab59-9322f9d5431d/robot.png",
      "height": 300,
      "width": 300
    },
    "rocket": {
      "path": "https://ucarecdn.com/93cdddd4-8ac9-4c8a-9749-f2c7782586f4/rocket.png",
      "height": 300,
      "width": 300
    },
    "sailing": {
      "path": "https://ucarecdn.com/62ca6ba4-f4cf-40b8-8ad8-01ed84232064/sailing.png",
      "height": 300,
      "width": 300
    },
    "sand": {
      "path": "https://ucarecdn.com/0abd0f0c-4243-4678-968d-dc7092ad0f9e/sand.png",
      "height": 300,
      "width": 300
    },
    "sculpture": {
      "path": "https://ucarecdn.com/392184e9-7f9e-48b9-a19a-519fa752c92a/sculpture.png",
      "height": 300,
      "width": 300
    },
    "shelter": {
      "path": "https://ucarecdn.com/006d1d22-b39d-403a-b4cc-071b63b35a66/shelter.png",
      "height": 300,
      "width": 300
    },
    "ship": {
      "path": "https://ucarecdn.com/c94201a2-abb2-45e3-81b2-a6548a13f302/ship.png",
      "height": 300,
      "width": 300
    },
    "siege_tower": {
      "path": "https://ucarecdn.com/e58e90df-d87a-47af-9a16-ca0450c3e598/siege_tower.png",
      "height": 300,
      "width": 300
    },
    "silicon": {
      "path": "https://ucarecdn.com/c6d120a2-1d66-45f7-abcb-b401b663e170/silicon.png",
      "height": 300,
      "width": 300
    },
    "sky": {
      "path": "https://ucarecdn.com/cc61dec9-8110-4dc8-8d1b-b5c9026be19d/sky.png",
      "height": 300,
      "width": 300
    },
    "smartphone": {
      "path": "https://ucarecdn.com/fc08e832-63a6-458d-84be-5e676c66f6bc/smartphone.png",
      "height": 300,
      "width": 300
    },
    "solar_panel": {
      "path": "https://ucarecdn.com/6fcb3066-aae2-4bd1-a887-e31a7245ff86/solar_panel.png",
      "height": 300,
      "width": 300
    },
    "sound": {
      "path": "https://ucarecdn.com/6a50ed28-c05c-401a-bf48-eb74206a5dec/sound.png",
      "height": 300,
      "width": 300
    },
    "space": {
      "path": "https://ucarecdn.com/422ff9cd-ccc2-4fde-9d50-8a25fed973d4/space.png",
      "height": 300,
      "width": 300
    },
    "space_station": {
      "path": "https://ucarecdn.com/73bc3623-9eed-44ec-adf5-c05478f10277/space_station.png",
      "height": 300,
      "width": 300
    },
    "sport": {
      "path": "https://ucarecdn.com/f4901f95-9c05-4df9-9fa4-6d9f602d0bca/sport.png",
      "height": 300,
      "width": 300
    },
    "star": {
      "path": "https://ucarecdn.com/f4ab791d-d09b-4e2a-95c1-f15025427ee3/star.png",
      "height": 300,
      "width": 300
    },
    "steam": {
      "path": "https://ucarecdn.com/80817aa3-08af-451e-a09e-d90f669e2eb2/steam_power.png",
      "height": 300,
      "width": 300
    },
    "stone": {
      "path": "https://ucarecdn.com/abb5c612-8561-43dd-a33c-00a8d253e740/stone.png",
      "height": 300,
      "width": 300
    },
    "storm": {
      "path": "https://ucarecdn.com/a3161b50-af52-4cf6-b11c-9f5ef3b29c03/storm.png",
      "height": 300,
      "width": 300
    },
    "story": {
      "path": "https://ucarecdn.com/c75b8599-ed85-4d58-a48a-d879aa7bdf8a/story.png",
      "height": 300,
      "width": 300
    },
    "submarine": {
      "path": "https://ucarecdn.com/b428fddd-a8b3-4faa-b145-3fde91648037/submarine.png",
      "height": 300,
      "width": 300
    },
    "sun": {
      "path": "https://ucarecdn.com/486db489-463a-4b2b-b4c6-93ae21ec036c/sun.png",
      "height": 300,
      "width": 300
    },
    "symbol": {
      "path": "https://ucarecdn.com/080f5a2e-0e38-4afa-a1cf-8a2ea7694fe2/symbol.png",
      "height": 300,
      "width": 300
    },
    "tank": {
      "path": "https://ucarecdn.com/715ec0e0-8322-4ec6-8a5d-420da724e183/tank.png",
      "height": 300,
      "width": 300
    },
    "telephone": {
      "path": "https://ucarecdn.com/1372e4a7-ddfc-4007-9779-dc7a30af984e/telephone.png",
      "height": 300,
      "width": 300
    },
    "telescope": {
      "path": "https://ucarecdn.com/88f60488-7ca4-479f-94ad-fc1e11db0565/telescope.png",
      "height": 300,
      "width": 300
    },
    "temple": {
      "path": "https://ucarecdn.com/84ee0269-72bb-4f90-b02b-0f36e99d6be9/temple.png",
      "height": 300,
      "width": 300
    },
    "terraformer": {
      "path": "https://ucarecdn.com/e9503535-4774-4437-8173-69c197518058/terraformer.png",
      "height": 300,
      "width": 300
    },
    "tool": {
      "path": "https://ucarecdn.com/86d061ad-e1c2-42d0-89b2-64f7df63c6d3/tool.png",
      "height": 300,
      "width": 300
    },
    "trade": {
      "path": "https://ucarecdn.com/eb5f023c-d97e-4895-8bb1-e047375e6f07/trade.png",
      "height": 300,
      "width": 300
    },
    "train": {
      "path": "https://ucarecdn.com/f93565f4-fff1-473b-a85f-0177d8955b7b/train.png",
      "height": 300,
      "width": 300
    },
    "travel": {
      "path": "https://ucarecdn.com/80b3a3ae-1ff9-44f1-986b-a1ffb80484b5/travel.png",
      "height": 300,
      "width": 300
    },
    "travel_poster": {
      "path": "https://ucarecdn.com/3f18feaa-6101-45ec-ac1c-2c41b92c9c24/travel_posters.png",
      "height": 300,
      "width": 300
    },
    "trawler_ship": {
      "path": "https://ucarecdn.com/27f1ba92-25a0-4105-b915-f8dc9c982b06/trawler_ship.png",
      "height": 300,
      "width": 300
    },
    "tree": {
      "path": "https://ucarecdn.com/86fed195-9a38-4690-b669-9583da1b90f4/tree.png",
      "height": 300,
      "width": 300
    },
    "tribe": {
      "path": "https://ucarecdn.com/41682fa6-6ddf-472f-af1c-5d1f3050a5e0/tribe.png",
      "height": 300,
      "width": 300
    },
    "tube": {
      "path": "https://ucarecdn.com/fabc9a84-2abc-4b6c-8695-886ac850af2a/tube.png",
      "height": 300,
      "width": 300
    },
    "voice": {
      "path": "https://ucarecdn.com/0195e745-7f70-4b20-b91d-12bf542c34c7/voice.png",
      "height": 300,
      "width": 300
    },
    "water": {
      "path": "https://ucarecdn.com/abfa2487-f085-4cdf-9b9b-13b3499526fc/water.png",
      "height": 300,
      "width": 300
    },
    "wheel": {
      "path": "https://ucarecdn.com/4b05d593-fadc-41aa-8996-633a994dc214/stone_wood_wheel.png",
      "height": 300,
      "width": 300
    },
    "wind": {
      "path": "https://ucarecdn.com/cf349eb6-e287-4fc1-b57c-6087348799e0/wind.png",
      "height": 300,
      "width": 300
    },
    "wire": {
      "path": "https://ucarecdn.com/8e4ab4bc-97fd-4504-ab6c-9576629fa4d9/wire.png",
      "height": 300,
      "width": 300
    },
    "wood": {
      "path": "https://ucarecdn.com/f7733665-147a-4072-b6bf-36324bec1e99/wood.png",
      "height": 300,
      "width": 300
    },
    "writing": {
      "path": "https://ucarecdn.com/95df71f5-ede3-4660-8ccd-fbd98d9cc5ec/writing.png",
      "height": 300,
      "width": 300
    }
  },
  "music": {
    "bronze_age": {
      "path": "https://ucarecdn.com/cca478b6-ca35-4004-93a6-2a4f0cf8c33d/bronze_age.ogg",
      "height": 300,
      "width": 300
    },
    "classical_age": {
      "path": "https://ucarecdn.com/110c782a-e501-43e7-b943-ce097030ae94/classical_age.mp3",
      "height": 300,
      "width": 300
    },
    "industrial_age": {
      "path": "https://ucarecdn.com/51b5c0eb-8d40-4de6-80a8-8ee0a87b47d7/industrial_age.mp3",
      "height": 300,
      "width": 300
    },
    "information_age": {
      "path": "https://ucarecdn.com/195dfff3-68ac-4643-b064-46d7072a4263/information_age.ogg",
      "height": 300,
      "width": 300
    },
    "medieval_age": {
      "path": "https://ucarecdn.com/9c493f84-832d-444a-a486-c40bc3518556/medieval_age.mp3",
      "height": 300,
      "width": 300
    },
    "modern_age": {
      "path": "https://ucarecdn.com/073728d7-bcc0-4533-be41-470fa643648b/modern_age.mp3",
      "height": 300,
      "width": 300
    },
    "primordial_age": {
      "path": "https://ucarecdn.com/412e6932-fcb4-4051-a4b0-60aa2d5bba8b/primordial_age.mp3",
      "height": 300,
      "width": 300
    },
    "renaissance": {
      "path": "https://ucarecdn.com/80e9276a-d64e-4b81-95c6-d3bfe7e19266/renaissance.ogg",
      "height": 300,
      "width": 300
    },
    "space_age": {
      "path": "https://ucarecdn.com/5273d2f9-4c39-4cc9-9eb4-12484caa6fa4/space_age.ogg",
      "height": 300,
      "width": 300
    },
    "stone_age": {
      "path": "https://ucarecdn.com/5f5b3e0d-cbb3-49af-b86c-5b25e76d8549/stone_age.mp3",
      "height": 300,
      "width": 300
    }
  },
  "sfx": {
    "combine_fail": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1bcf63c161254429a06d4cc99fa31aeb/cf18b4c1766147359faa6962f758d468/preview/assets/sfx/combine_fail.ogg"
    },
    "combine_success": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1bcf63c161254429a06d4cc99fa31aeb/cf18b4c1766147359faa6962f758d468/preview/assets/sfx/combine_success.ogg"
    },
    "lose_round": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1bcf63c161254429a06d4cc99fa31aeb/57d02c1f6f8f4e1dac448c97cdd235c4/preview/assets/sfx/lose_round.ogg"
    },
    "new_discovery": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1bcf63c161254429a06d4cc99fa31aeb/cf18b4c1766147359faa6962f758d468/preview/assets/sfx/new_discovery.ogg"
    },
    "new_era": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1bcf63c161254429a06d4cc99fa31aeb/cf18b4c1766147359faa6962f758d468/preview/assets/sfx/new_era.ogg"
    },
    "play_card": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1bcf63c161254429a06d4cc99fa31aeb/57d02c1f6f8f4e1dac448c97cdd235c4/preview/assets/sfx/play_card.ogg"
    },
    "win_round": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1bcf63c161254429a06d4cc99fa31aeb/57d02c1f6f8f4e1dac448c97cdd235c4/preview/assets/sfx/win_round.ogg"
    }
  }
};
